// Translate Shopify native sort-by options (platform strings, not in theme locale)
// English storefront keeps Shopify's native English labels — nothing to translate.
(function translateSortOptions() {
  if (window.mawjStrings && window.mawjStrings.locale && window.mawjStrings.locale !== 'ar') return;
  var map = {
    'Best selling': 'الأكثر مبيعاً',
    'Featured': 'مميز',
    'Most relevant': 'الأكثر صلة',
    'Alphabetically, A-Z': 'أبجدياً، أ-ي',
    'Alphabetically, Z-A': 'أبجدياً، ي-أ',
    'Price, low to high': 'السعر: الأقل أولاً',
    'Price, high to low': 'السعر: الأعلى أولاً',
    'Date, new to old': 'الأحدث أولاً',
    'Date, old to new': 'الأقدم أولاً',
    'Newest': 'الأحدث',
    'Oldest': 'الأقدم'
  };

  function translateNode(el) {
    var text = el.textContent.trim();
    var t = map[text];
    if (t) el.textContent = t;
  }

  function translate(root) {
    root = root || document;
    // Native select options
    root.querySelectorAll('select[name="sort_by"] option').forEach(translateNode);
    // Minimog custom dropdown list items
    root.querySelectorAll('.m-select-custom--option').forEach(translateNode);
    // Minimog custom dropdown trigger label (visible text)
    root.querySelectorAll('.m-select-custom--trigger-text').forEach(translateNode);
    // Mobile sort items
    root.querySelectorAll('.m-sortby-mobile--item span, .m-sortby-mobile--item').forEach(translateNode);
  }

  document.addEventListener('DOMContentLoaded', function() { translate(); });

  // Re-translate after Minimog dynamically re-renders dropdowns
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) translate(node);
      });
      // Also re-check trigger text when attributes change (active state updates)
      if (m.type === 'characterData' || m.type === 'childList') {
        if (m.target && m.target.classList && m.target.classList.contains('m-select-custom--trigger-text')) {
          translateNode(m.target);
        }
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  });
})();

// Bypass AJAX cart interception for checkout landing page forms
(function bypassAjaxCartForCheckout() {
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && form.action && (form.action.indexOf('/cart/add') !== -1 || form.action.indexOf('/cart_add_url') !== -1)) {
      var returnTo = form.querySelector('input[name="return_to"]');
      if (returnTo && returnTo.value === '/checkout') {
        // Stop the submit event from bubbling up to document/body level theme scripts
        e.stopPropagation();
      }
    }
  }, true); // Use capture phase to intercept before theme bubble delegation
})();

// Coordinate shape selectors, gift box add-on, and ATC forms across landing pages
(function coordinateLanderSelectors() {

  // ---  Multi-item checkout (crystal + box) ---
  // NOTE: Must be document-level capture (not form-level) because bypassAjaxCartForCheckout
  // calls e.stopPropagation() at document capture, which prevents events reaching form listeners.
  // Multiple document-level capture listeners all fire regardless of stopPropagation.
  function initGiftBoxCheckout() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      // Only handle our ATC forms
      if (!form || !form.classList.contains('mawj-atc-form')) return;

      // Find the checked add-ons — either forces the JS multi-item flow
      var boxToggle = document.querySelector('.mawj-box-toggle:checked');
      var secondToggle = document.querySelector('.mawj-second-toggle:checked');
      if (!boxToggle && !secondToggle) return; // plain single-piece — native bypass flow handles it

      // Add-on selected — we take full control
      e.preventDefault();
      e.stopPropagation();

      // Second piece with "different photo" chosen but nothing uploaded → block
      if (secondToggle) {
        var p2Same = document.querySelector('.mawj-p2-same');
        var p2Input = document.querySelector('.mpu__input[name="p2_photo"]');
        if (p2Same && !p2Same.checked && (!p2Input || !p2Input.files || !p2Input.files[0])) {
          var p2Mpu = p2Input && p2Input.closest('.mpu');
          if (p2Mpu) {
            p2Mpu.scrollIntoView({ behavior: 'smooth', block: 'center' });
            var p2Err = p2Mpu.querySelector('.mpu__error');
            if (p2Err) { p2Err.textContent = window.mawjStrings.secondPiecePhotoRequired; p2Err.hidden = false; }
          }
          return;
        }
      }

      // Form has no own uploader but the page requires a photo that's missing → block
      if (!form.querySelector('.mpu__input')) {
        var pagePhotoInput = getPagePhotoInput();
        if (pagePhotoInput && (!pagePhotoInput.files || !pagePhotoInput.files[0])) {
          var mpuBox = pagePhotoInput.closest('.mpu');
          if (mpuBox) {
            mpuBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
            var mpuErr = mpuBox.querySelector('.mpu__error');
            if (mpuErr) { mpuErr.textContent = window.mawjStrings.photoRequired; mpuErr.hidden = false; }
          }
          return;
        }
      }

      var crystalVariantId = form.querySelector('input[name="id"]').value;
      var boxVariantId = boxToggle && boxToggle.getAttribute('data-box-variant-id');
      if (!crystalVariantId) return;

      // Disable button to prevent double-submit
      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.style.opacity = '0.6';
      }

      // Clear cart, add piece 1 (multipart — keeps photo upload properties),
      // then piece 2 / gift box as selected, then go to checkout
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function() {
          var fd = new FormData(form);
          fd.delete('return_to');
          fd.delete('p2_photo');
          fd.delete('p2_same');
          attachPagePhoto(fd, form);
          if (secondToggle) fd.set('properties[القطعة]', 'الأولى من قطعتين');
          return fetch('/cart/add.js', { method: 'POST', body: fd });
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Piece 1 add failed: ' + res.status);
          if (!secondToggle) return res;
          // Piece 2: own variant (shape), own photo (or piece 1's)
          var shapeBtn = document.querySelector('.mawj-p2-shape.is-active');
          var fd2 = new FormData();
          fd2.set('id', shapeBtn ? shapeBtn.getAttribute('data-variant') : crystalVariantId);
          fd2.set('quantity', 1);
          fd2.set('properties[القطعة]', 'الثانية من قطعتين (خصم 20 د.إ)');
          var p2SameChk = document.querySelector('.mawj-p2-same');
          var photo2 = null;
          if (p2SameChk && !p2SameChk.checked) {
            var p2In = document.querySelector('.mpu__input[name="p2_photo"]');
            photo2 = p2In && p2In.files && p2In.files[0];
          } else {
            var mainIn = getPagePhotoInput();
            photo2 = mainIn && mainIn.files && mainIn.files[0];
          }
          if (photo2) fd2.set(PHOTO_PROPERTY, photo2);
          return fetch('/cart/add.js', { method: 'POST', body: fd2 }).then(function(r2) {
            if (!r2.ok) throw new Error('Piece 2 add failed: ' + r2.status);
            return r2;
          });
        })
        .then(function() {
          if (!boxVariantId) return null;
          // one luxury box per piece — 2 pieces means 2 boxes
          var boxQty = secondToggle ? 2 : 1;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(boxVariantId, 10), quantity: boxQty }] })
          }).then(function(rb) {
            if (!rb.ok) throw new Error('Box add failed: ' + rb.status);
            return rb;
          });
        })
        .then(function() {
          window.location.href = '/checkout';
        })
        .catch(function(err) {
          console.error('[Mawj] Multi-item checkout error:', err);
          if (btn) { btn.disabled = false; btn.style.opacity = '1'; }
        });
    }, true); // capture phase — fires alongside bypassAjaxCartForCheckout
  }

  // ---  Shape selector tile clicks ---
  function initSelectors() {
    var tiles = document.querySelectorAll('.mawj-shape-tile');
    if (tiles.length === 0) return;

    tiles.forEach(function(tile) {
      tile.addEventListener('click', function() {
        var shape = tile.getAttribute('data-shape');
        var variantId = tile.getAttribute('data-variant-id');
        var price = tile.getAttribute('data-price');
        var comparePrice = tile.getAttribute('data-compare-price');
        var img = tile.getAttribute('data-img');
        var title = tile.getAttribute('data-title');

        // 1. Toggle active state on all tiles
        document.querySelectorAll('.mawj-shape-tile').forEach(function(t) {
          t.classList.toggle('is-active', t.getAttribute('data-shape') === shape);
        });

        // 2. Update variant ID in ALL ATC forms
        document.querySelectorAll('input[name="id"]').forEach(function(input) {
          input.value = variantId;
        });

        // 3. Update displayed price-now
        document.querySelectorAll('[data-price-display="now"]').forEach(function(el) {
          el.textContent = price;
        });

        // 4. Update displayed price-was
        document.querySelectorAll('[data-price-display="was"]').forEach(function(el) {
          var show = comparePrice && Number(comparePrice) > Number(price);
          if (show) {
            el.textContent = comparePrice;
          }
          el.style.display = show ? 'inline' : 'none';
          var parent = el.closest('.mhtt__price-was, .mawj-ob__was, .mlh__price-was, del');
          if (parent) parent.style.display = show ? 'inline' : 'none';
        });

        // 5. Update savings badge
        document.querySelectorAll('[data-price-display="save"]').forEach(function(el) {
          var show = comparePrice && Number(comparePrice) > Number(price);
          if (show) el.textContent = Number(comparePrice) - Number(price);
          var parent = el.closest('.mhtt__save, .mawj-ob__save, .mlo-save-badge-container');
          if (parent) parent.style.display = show ? 'inline-block' : 'none';
        });

        // 6. Update hero preview images
        document.querySelectorAll('[data-hero-preview-image]').forEach(function(el) {
          if (img) { el.src = img; el.srcset = ''; el.style.display = 'block'; }
        });

        // 7. Hide video when shape clicked
        document.querySelectorAll('[data-hero-preview-video]').forEach(function(el) {
          el.style.display = 'none';
        });

        // 8. Update sticky bar image and title
        document.querySelectorAll('[data-sticky-image]').forEach(function(el) {
          if (img) { el.src = img; el.srcset = ''; }
        });
        document.querySelectorAll('[data-sticky-title]').forEach(function(el) {
          if (title) el.textContent = title;
        });

        // 9. Recalculate combined price if box is checked
        updateCombinedPrice(price);
      });
    });
  }

  // ---  Gift box toggle ---
  function updateCombinedPrice(crystalPrice) {
    document.querySelectorAll('.mawj-box-toggle').forEach(function(toggle) {
      var boxPrice = parseFloat(toggle.getAttribute('data-box-price') || '0');
      var crystal = parseFloat(crystalPrice || '0');
      var totalEl = toggle.closest('.mawj-box-addon') &&
                    toggle.closest('.mawj-box-addon').querySelector('[data-combined-price]');
      if (totalEl && toggle.checked) {
        totalEl.textContent = (crystal + boxPrice).toFixed(0);
      }
    });
  }

  function initBoxToggle() {
    document.querySelectorAll('.mawj-box-toggle').forEach(function(toggle) {
      toggle.addEventListener('change', function() {
        var addon = toggle.closest('.mawj-box-addon');
        if (!addon) return;

        // Update ATC button text across page
        var btns = document.querySelectorAll('.mawj-atc-form button[type="submit"]');
        btns.forEach(function(btn) {
          var baseLabel = btn.getAttribute('data-base-label') || btn.textContent.trim();
          if (!btn.hasAttribute('data-base-label')) btn.setAttribute('data-base-label', baseLabel);
          btn.textContent = toggle.checked ? window.mawjStrings.addCrystalAndBox : baseLabel;
        });

        // Show/hide combined price
        var now = document.querySelector('[data-price-display="now"]');
        var crystal = now ? parseFloat(now.textContent) : 0;
        var boxPrice = parseFloat(toggle.getAttribute('data-box-price') || '0');

        document.querySelectorAll('[data-combined-price]').forEach(function(el) {
          el.textContent = toggle.checked
            ? (crystal + boxPrice).toFixed(0)
            : (now ? now.textContent : '');
        });
      });
    });
  }

  // ---  Customer photo upload (snippets/mawj-photo-upload.liquid) ---
  var MAX_PHOTO_BYTES = 20 * 1024 * 1024; // Shopify cart upload limit
  var PHOTO_PROPERTY = 'properties[صورة العميل]';

  function getPagePhotoInput() {
    // Main-photo inputs only — piece-2 uploaders use a plain name (p2_photo)
    var inputs = document.querySelectorAll('.mpu__input[name="' + PHOTO_PROPERTY + '"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].files && inputs[i].files[0]) return inputs[i];
    }
    return inputs[0] || null;
  }

  // If this form's FormData carries no photo, borrow the one uploaded elsewhere on the page
  function attachPagePhoto(fd, form) {
    if (form.querySelector('.mpu__input')) return; // form has its own uploader
    var existing = fd.get(PHOTO_PROPERTY);
    if (existing && existing.size > 0) return;
    var pageInput = getPagePhotoInput();
    if (pageInput && pageInput.files && pageInput.files[0]) {
      fd.set(PHOTO_PROPERTY, pageInput.files[0]);
    }
  }

  // ---  Second-piece add-on UI (lander order forms) ---
  function initSecondPiece() {
    document.querySelectorAll('.mawj-second-toggle').forEach(function(toggle) {
      var head = toggle.closest('.mawj-second-head');
      var panel = head && head.nextElementSibling && head.nextElementSibling.classList.contains('mawj-second-panel')
        ? head.nextElementSibling : document.querySelector('.mawj-second-panel');
      toggle.addEventListener('change', function() {
        if (panel) panel.hidden = !toggle.checked;
      });
    });
    document.querySelectorAll('.mawj-p2-shape').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.mawj-p2-shape').forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
    document.querySelectorAll('.mawj-p2-same').forEach(function(chk) {
      chk.addEventListener('change', function() {
        var wrap = document.querySelector('.mawj-p2-upload');
        if (wrap) wrap.hidden = chk.checked;
      });
    });
  }

  // ATC forms WITHOUT their own uploader (e.g. sticky bar): require/borrow the page photo
  function initPhotoRelay() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.classList.contains('mawj-atc-form')) return;
      if (e.defaultPrevented) return; // gift-box handler took over (it borrows the photo itself)
      if (form.querySelector('.mpu__input')) return; // native multipart submit carries the file
      var pageInput = getPagePhotoInput();
      if (!pageInput) return; // page has no uploader at all — leave flow untouched

      e.preventDefault();
      e.stopPropagation();

      if (!pageInput.files || !pageInput.files[0]) {
        // photo missing — take customer to the uploader
        var mpu = pageInput.closest('.mpu');
        if (mpu) {
          mpu.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var err = mpu.querySelector('.mpu__error');
          if (err) { err.textContent = window.mawjStrings.photoRequired; err.hidden = false; }
        }
        return;
      }

      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }

      var fd = new FormData(form);
      fd.delete('return_to');
      fd.set(PHOTO_PROPERTY, pageInput.files[0]);
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function(res) {
          if (!res.ok) throw new Error('Cart add failed: ' + res.status);
          window.location.href = '/checkout';
        })
        .catch(function(err) {
          console.error('[Mawj] Photo relay checkout error:', err);
          if (btn) { btn.disabled = false; btn.style.opacity = '1'; }
        });
    }, true);
  }

  function initPhotoUpload() {
    document.querySelectorAll('.mpu').forEach(function(root) {
      var input = root.querySelector('.mpu__input');
      var preview = root.querySelector('.mpu__preview');
      var thumb = root.querySelector('.mpu__thumb');
      var filename = root.querySelector('.mpu__filename');
      var removeBtn = root.querySelector('.mpu__remove');
      var errorEl = root.querySelector('.mpu__error');
      if (!input || !preview) return;

      function setError(msg) {
        if (!errorEl) return;
        errorEl.textContent = msg || '';
        errorEl.hidden = !msg;
      }

      function clearFile() {
        input.value = '';
        root.classList.remove('has-file');
        preview.hidden = true;
        if (thumb) thumb.src = '';
        setError('');
      }

      input.addEventListener('change', function() {
        var file = input.files && input.files[0];
        if (!file) { clearFile(); return; }
        if (file.size > MAX_PHOTO_BYTES) {
          clearFile();
          setError(window.mawjStrings.photoTooLarge);
          return;
        }
        if (file.type && file.type.indexOf('image/') !== 0) {
          clearFile();
          setError(window.mawjStrings.photoNotImage);
          return;
        }
        setError('');
        if (filename) filename.textContent = file.name;
        var reader = new FileReader();
        reader.onload = function(ev) {
          if (thumb) thumb.src = ev.target.result;
          preview.hidden = false;
          root.classList.add('has-file');
        };
        reader.readAsDataURL(file);
      });

      if (removeBtn) {
        removeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          clearFile();
        });
      }
    });
  }

  function init() {
    initSelectors();
    initGiftBoxCheckout();
    initBoxToggle();
    initPhotoUpload();
    initPhotoRelay();
    initSecondPiece();
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  }
})();
